import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody, CardHeader, Nav, NavItem, NavLink, TabContent } from 'reactstrap';
import Badge from './badge';
import ChecksTab from './checksTab';
import FollowupsTab from './followupsTab';
const TabsSection = _ref => {
  let activeTab = _ref.activeTab,
    onTabChange = _ref.onTabChange,
    checksArray = _ref.checksArray,
    followupsArray = _ref.followupsArray,
    unanalyzedFollowupsCount = _ref.unanalyzedFollowupsCount,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? null : _ref$content,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '' : _ref$path,
    _ref$formActions = _ref.formActions,
    formActions = _ref$formActions === void 0 ? null : _ref$formActions,
    _ref$reduxEntity = _ref.reduxEntity,
    reduxEntity = _ref$reduxEntity === void 0 ? '' : _ref$reduxEntity,
    _ref$pendingOperation = _ref.pendingOperation,
    pendingOperation = _ref$pendingOperation === void 0 ? false : _ref$pendingOperation,
    _ref$notificationActi = _ref.notificationActions,
    notificationActions = _ref$notificationActi === void 0 ? null : _ref$notificationActi;
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-4 quality-agent__tabs-card"
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "quality-agent__tabs-header"
  }, /*#__PURE__*/React.createElement(Nav, {
    tabs: true,
    className: "border-bottom-0"
  }, /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavLink, {
    className: activeTab === 'checks' ? 'active quality-agent__tab-link' : 'quality-agent__tab-link',
    onClick: () => onTabChange('checks')
  }, "Checks", /*#__PURE__*/React.createElement(Badge, {
    tag: "span",
    color: "secondary",
    pill: true,
    className: "quality-agent__tab-badge"
  }, checksArray.length))), followupsArray.length > 0 && /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavLink, {
    className: activeTab === 'followups' ? 'active quality-agent__tab-link' : 'quality-agent__tab-link',
    onClick: () => onTabChange('followups')
  }, "Suggested Followups", /*#__PURE__*/React.createElement(Badge, {
    tag: "span",
    color: "primary",
    pill: true,
    className: "quality-agent__tab-badge"
  }, unanalyzedFollowupsCount))))), /*#__PURE__*/React.createElement(CardBody, {
    className: "p-0 quality-agent__tab-content-wrapper"
  }, /*#__PURE__*/React.createElement(TabContent, {
    activeTab: activeTab
  }, /*#__PURE__*/React.createElement(ChecksTab, {
    checksArray: checksArray
  }), followupsArray.length > 0 && /*#__PURE__*/React.createElement(FollowupsTab, {
    followupsArray: followupsArray,
    content: content,
    path: path,
    formActions: formActions,
    reduxEntity: reduxEntity,
    pendingOperation: pendingOperation,
    notificationActions: notificationActions
  }))));
};
TabsSection.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  checksArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired,
  followupsArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired,
  unanalyzedFollowupsCount: PropTypes.number.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    formType: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  path: PropTypes.string,
  formActions: PropTypes.shape({
    change: PropTypes.func.isRequired
  }),
  reduxEntity: PropTypes.string,
  pendingOperation: PropTypes.bool,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  })
};
export default TabsSection;